<template>
  <header class="ba-mb-4">
    <div class="ba-mb-4 ba-pb-4 ba-border-b-2 ba-border-background-blocks">
      <h2 class="ba-mb-3 ba-text-base ba-font-semibold">Бизнес-процессы</h2>
      <div class="ba-inline-flex ba-items-center ba-px-4 ba-py-2 ba-text-white ba-bg-success-strong ba-rounded-full ba-select-none">
        <vis-icon-done class="ba-w-3 ba-h-3 ba-mr-2" />
        <span class="ba-whitespace-no-wrap">На согласование</span>
      </div>
    </div>
    <!-- ================ -->
    <div class="ba-flex ba-justify-between ba-items-center">
      <p class="ba-flex ba-items-center ba-flex-wrap ba-mr-2 ba-font-semibold">
        <span class="ba-mr-2 ba-whitespace-no-wrap">Текущая версия согласования:</span>
        <span class="ba-leading-none ba-whitespace-no-wrap ba-text-accent">
          <span class="ba-mr-1">от</span>
          <span class="ba-mr-1">15.03.2021</span>
          <span>15:40</span>
        </span>
      </p>
      <visApprovalQueueHistoryControl />
    </div>
  </header>
</template>

<script>
import visApprovalQueueHistoryControl from "./vis-approval-queue-history-control";

export default {
  name: "vis-approval-queue-header",
  components: {
    visApprovalQueueHistoryControl
  }
};
</script>
